import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaChartPie,
  FaClock,
  FaPlusCircle,
  FaMoneyBill,
  FaTasks,
  FaRegFilePdf,
  FaUserSlash,
  FaClipboardList,
  FaMoneyBillWave,
  FaReceipt,
} from "react-icons/fa";
import {
  MdPeople,
  MdLockOpen,
  MdCheckCircle,
  MdInventory,
  MdAttachMoney,
} from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { FcSalesPerformance } from "react-icons/fc";
import { GiMoneyStack } from "react-icons/gi";
import "./AdminSidebar.css";

import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
const iconMap = {
  "Admin Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Employee Management": <MdPeople style={{ color: "#FFC300" }} />,
  "Salary Management": <FaChartPie style={{ color: "Plum" }} />,
  "Loan Management": <FaMoneyBillWave style={{ color: "#A8DF8E" }} />,
  Perfomance: <FcSalesPerformance style={{ color: "#FEB941" }} />,
  "Attendance Management": <FaClock style={{ color: "Turquoise" }} />,
  Projects: <FaPlusCircle style={{ color: "yellow" }} />,
  "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
  "Payroll Management": <MdAttachMoney style={{ color: "yellow" }} />,
  "Expense Payroll": <FaPlusCircle style={{ color: "orange" }} />,
  Arrear: <GiMoneyStack style={{ color: "green" }} />,
  Contract: <MdAttachMoney style={{ color: "green" }} />,
  "Account Ledger": <MdAttachMoney style={{ color: "yellow" }} />,
  "Office Inventory": <MdInventory style={{ color: "#41B06E" }} />,
  "Leave Approval": <MdCheckCircle style={{ color: "pink" }} />,
  "Balance Leave": <FaClipboardList style={{ color: "#41B06E" }} />,
  "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  Access: <MdLockOpen style={{ color: "yellow" }} />,
  "Work Dashboard": <FaTasks style={{ color: "#78B7FF" }} />,
  "Create Workspace": <FaPlusCircle style={{ color: "green" }} />,
  File: <FaReceipt style={{ color: "#FEB941" }} />,
  "Task Overview": <FaTasks style={{ color: "pink" }} />,
  Policy: <FaRegFilePdf style={{ color: "red" }} />,
  "Inactive Employee": <FaUserSlash style={{ color: "#96C9F4" }} />,
  Settings: <IoMdSettings style={{ color: "yellow" }} />,
};

const adminLinks = [
  { to: "/admin/AdminDashboard", name: "Admin Dashboard" },
  {
    to: "/admin/employee-management",
    name: "Employee Management",
    moduleName: "Employee Management",
    roleName: "Employee Management",
  },
  { to: "/admin/salary-management", name: "Salary Management" },
  { to: "/admin/loan-management", name: "Loan Management" },
  { to: "/admin/performance", name: "Perfomance" },
  {
    to: "/admin/attendance-management",
    name: "Attendance Management",
    moduleName: "Attendance Management",
    roleName: "Attendance Management",
  },
  { to: "/admin/Createproject", name: "Projects" },
  {
    to: "/admin/expense-management",
    name: "Expense Management",
    moduleName: "Expense Management",
    roleName: "View Expense",
  },
  {
    to: "/admin/payroll-management",
    name: "Payroll Management",
    moduleName: "Payroll Management",
    roleName: "View Payroll",
  },
  {
    to: "/admin/expense-payroll",
    name: "Expense Payroll",
    moduleName: "Expense Payroll Management",
    roleName: "View Expense Payroll",
  },
  { to: "/admin/arrear", name: "Arrear" },
  { to: "/admin/Contract", name: "Contract" },
  {
    to: "/admin/account-ledger",
    name: "Account Ledger",
    moduleName: "Ledger Management",
    roleName: "View Ledger",
  },
  { to: "/admin/office-inventory", name: "Office Inventory" },
  {
    to: "/admin/LeaveApprovalAdmin",
    name: "Leave Approval",
    moduleName: "Leave Management",
    roleName: "Approve/Reject Leave",
  },
  { to: "/admin/Balance-leave", name: "Balance Leave" },
  { to: "/admin/add-leave-wfh", name: "Add Leave/WFH" },
  { to: "/admin/access", name: "Access" },
  {
    to: "/admin/work-dashboard",
    name: "Work Dashboard",
    moduleName: "Project Management",
    roleName: "View Projects",
  },
  {
    to: "/admin/create-workspace",
    name: "Create Workspace",
    moduleName: "Project Management",
    roleName: "View Projects",
  },
  { to: "/admin/file", name: "File" },
  { to: "/admin/task-overview", name: "Task Overview" },
  {
    to: "/admin/policy",
    name: "Policy",
    moduleName: "Policy Management",
    roleName: "View Policy",
  },
  { to: "/admin/inactive-employee", name: "Inactive Employee" },
  { to: "/admin/admin-settings", name: "Settings" },
];

const adminGroups = [
  { title: "Overview", items: ["Admin Dashboard"] },
  {
    title: "People & Attendance",
    items: [
      "Employee Management",
      "Attendance Management",
      "Leave Approval",
      "Balance Leave",
      "Add Leave/WFH",
      "Perfomance",
      "Inactive Employee",
    ],
  },
  {
    title: "Work & Projects",
    items: [
      "Projects",
      "Create Workspace",
      "Work Dashboard",

      "Task Overview",
      "File",
    ],
  },
  {
    title: "Payroll & Finance",
    items: [
      "Salary Management",
      "Payroll Management",
      "Expense Payroll",
      "Expense Management",
      "Loan Management",
      "Arrear",
      "Contract",
      "Account Ledger",
    ],
  },
  { title: "Organization", items: ["Office Inventory", "Policy"] },
  { title: "Administration", items: ["Access", "Settings"] },
];

const AdminSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessData, setAccessData } = useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        },
      );
      const data = await res.json();
      if (data.status === "0") setAccessData(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);

  const navigationLinks = adminLinks.map((link) => {
    let access = true;
    if (link.moduleName && link.roleName) {
      const moduleData = accessData?.find(
        (m) => m.module_name === link.moduleName,
      );
      const dataArray = Array.isArray(moduleData?.data) ? moduleData.data : [];
      access = !!dataArray.find(
        (r) =>
          r.role_name?.trim() === link.roleName?.trim() && r.access === "Y",
      );
    }
    return { ...link, access };
  });
  return (
    <nav className="admin-sidebar" aria-label="Admin navigation">
      <h5 className="admin-sidebar-title">Admin System</h5>
      {adminGroups.map((group) => (
        <section
          className="admin-sidebar-group"
          key={group.title}
          aria-label={group.title}
        >
          <h6 className="admin-sidebar-group-title">{group.title}</h6>
          <ul className="admin-sidebar-links">
            {group.items.map((name) => {
              const link = navigationLinks.find((item) => item.name === name);
              const access = link.access !== false;
              const active = pathname === link.to;
              return (
                <li key={link.to} title={access ? undefined : "Access Denied"}>
                  <Link
                    to={access ? link.to : "#"}
                    className={`admin-sidebar-link${active ? " is-active" : ""}${access ? "" : " is-disabled"}`}
                    aria-current={active ? "page" : undefined}
                    aria-disabled={!access}
                    tabIndex={access ? undefined : -1}
                    onClick={(event) => {
                      if (!access) event.preventDefault();
                    }}
                  >
                    <span className="admin-sidebar-icon" aria-hidden="true">
                      {iconMap[link.name] || null}
                    </span>
                    <span className="admin-sidebar-label">{link.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </nav>
  );
};

export default AdminSidebar;
